"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toYaml = exports.fromYaml = exports.YAML = void 0;
var js_yaml_1 = require("js-yaml");
var Dictionary_1 = require("./Dictionary");
var Str_1 = require("./Str");
var lodash_1 = require("lodash");
var Int64_1 = require("./Int64");
var UInt64_1 = require("./UInt64");
var U32_1 = require("./U32");
var DataHash_1 = require("./DataHash");
var __1 = require("../..");
var buffer_1 = require("buffer");
var DataPublicKey_1 = require("./DataPublicKey");
var DataLock_1 = require("./DataLock");
var BigInteger = require("bigi");
var YAML;
(function (YAML) {
    function isDecCode(c) {
        return ((0x30 /* 0 */ <= c) && (c <= 0x39 /* 9 */));
    }
    function isNumber(data) {
        for (var index = 0; index < data.length; index++) {
            if (!isDecCode(data.charCodeAt(index))) {
                return false;
            }
        }
        return true;
    }
    function isHex(data) {
        var re = /^[0-9a-f]+$/g;
        return re.test(data);
    }
    var DictionaryYamlType = new js_yaml_1.Type('tag:yaml.org,2002:map', {
        kind: 'mapping',
        construct: function (data) {
            if (!data)
                throw new Error('not a dictionary');
            return new Dictionary_1.Dictionary(data);
        },
        instanceOf: Dictionary_1.Dictionary,
        represent: function (data) {
            return data.data;
        }
    });
    var StringYamlType = new js_yaml_1.Type('tag:yaml.org,2002:str', {
        kind: 'scalar',
        construct: function (data) {
            if (!data)
                throw new Error('not a string');
            return new Str_1.Str(data);
        },
        instanceOf: Str_1.Str,
        represent: function (data) {
            return data.s;
        }
    });
    var Int64YamlType = new js_yaml_1.Type('tag:yaml.org,2002:int', {
        kind: 'scalar',
        resolve: function (data) {
            if (typeof data === 'number') {
                return lodash_1.isInteger(data);
            }
            else if (typeof data === 'string') {
                if (data[0] === '-') {
                    data = data.substr(1);
                }
                return isNumber(data);
            }
            return false;
        },
        construct: function (data) {
            if (typeof data === 'number') {
                return new Int64_1.Int64(new BigInteger(data.toString(), 10, undefined));
            }
            return new Int64_1.Int64(new BigInteger(data, 10, undefined));
        },
        instanceOf: Int64_1.Int64,
        represent: function (data) {
            return data.value.toString();
        }
    });
    var UInt64YamlType = new js_yaml_1.Type('!uint64', {
        kind: 'scalar',
        resolve: function (data) {
            if (typeof data === 'string' && lodash_1.endsWith(data, 'UL')) {
                var amount = data.substr(0, data.length - 2);
                return isNumber(amount);
            }
            return false;
        },
        construct: function (data) {
            if (typeof data === 'string') {
                var amount = data.substr(0, data.length - 2);
                return new UInt64_1.UInt64(new BigInteger(amount, 10, undefined));
            }
        },
        instanceOf: UInt64_1.UInt64,
        represent: function (data) {
            return data.value.toString() + 'UL';
        }
    });
    var UInt32YamlType = new js_yaml_1.Type('!uint32', {
        kind: 'scalar',
        resolve: function (data) {
            if (typeof data === 'string' && lodash_1.endsWith(data, 'ul')) {
                var amount = data.substr(0, data.length - 2);
                return isNumber(amount);
            }
            return false;
        },
        construct: function (data) {
            if (typeof data === 'string') {
                var amount = data.substr(0, data.length - 2);
                return new U32_1.U32(new BigInteger(amount, 10, undefined));
            }
        },
        instanceOf: U32_1.U32,
        represent: function (data) {
            return data.value.toString() + 'ul';
        }
    });
    var HashYamlType = new js_yaml_1.Type('!hash', {
        kind: 'scalar',
        resolve: function (data) {
            return typeof data === "string" && data.length === 64 && isHex(data);
        },
        construct: function (data) {
            if (typeof data === 'string') {
                return new DataHash_1.DataHash(new __1.Hash(data));
            }
        },
        instanceOf: DataHash_1.DataHash,
        represent: function (hash) {
            return hash.toString();
        }
    });
    var ZenAmountYamlType = new js_yaml_1.Type('!zen', {
        kind: 'scalar',
        resolve: function (data) {
            if (typeof data === 'string' && lodash_1.endsWith(data, 'ZP')) {
                var amount = data.substr(0, data.length - 2);
                if (isNumber(amount)) {
                    return true;
                }
                else {
                    var decimalPoint = amount.indexOf('.');
                    if (decimalPoint === -1) {
                        return false;
                    }
                    var x = amount.substr(0, decimalPoint);
                    var y = amount.substr(decimalPoint + 1);
                    return isNumber(x) && isNumber(y);
                }
            }
            return false;
        },
        construct: function (data) {
            // TODO:handle the case of number higher than javascript maximum
            var amount = data.substr(0, data.length - 2).trim();
            var decimalPoint = amount.indexOf('.');
            var decimalLength = 0;
            if (decimalPoint !== -1) {
                decimalLength = amount.length - decimalPoint - 1;
            }
            var multiplier = Math.pow(10, 8 - decimalLength);
            return new UInt64_1.UInt64(new BigInteger(lodash_1.replace(amount, '.', ''), 10, undefined).multiply(BigInteger.valueOf(multiplier)));
        }
    });
    var PublicKeyYamlType = new js_yaml_1.Type('!pk', {
        kind: 'scalar',
        construct: function (data) {
            var buffer = buffer_1.Buffer.from(data, 'hex');
            var publicKey = __1.PublicKey.deserialize(buffer);
            return new DataPublicKey_1.DataPublicKey(publicKey);
        },
        instanceOf: DataLock_1.DataLock,
        represent: function (pk) {
            return pk.serialize().toString('hex');
        }
    });
    var basicSchema = new js_yaml_1.Schema({
        implicit: [ZenAmountYamlType, UInt64YamlType, Int64YamlType, UInt32YamlType],
        explicit: [
            StringYamlType,
            DictionaryYamlType,
            PublicKeyYamlType
        ],
        include: []
    });
    function createSchema(chain) {
        var AddressYamlType = new js_yaml_1.Type('!address', {
            kind: 'scalar',
            resolve: function (data) {
                if (typeof data === 'string') {
                    try {
                        __1.Address.decode(chain, data);
                        return true;
                    }
                    catch (ex) {
                        return false;
                    }
                }
                return false;
            },
            construct: function (data) {
                var address = __1.Address.decode(chain, data);
                if (address instanceof __1.Hash)
                    return new DataLock_1.DataLock(new __1.PK(address));
                else {
                    return new DataLock_1.DataLock(new __1.Contract(address));
                }
            },
            instanceOf: DataLock_1.DataLock,
            represent: function (pkLock) {
                return new DataLock_1.DataLock(pkLock);
            }
        });
        return new js_yaml_1.Schema({
            include: [basicSchema],
            implicit: [AddressYamlType, HashYamlType],
            explicit: []
        });
    }
    function fromYaml(chain, yaml) {
        // console.log(createSchema(chain))
        var data = js_yaml_1.safeLoad(yaml, { schema: createSchema(chain) });
        // replacing object and strings
        function visit(node) {
            if (lodash_1.isPlainObject(node)) {
                var pairs = lodash_1.toPairs(node).map(function (pair) {
                    var key = pair[0];
                    var value = visit(pair[1]);
                    return [key, value];
                });
                return new Dictionary_1.Dictionary(pairs);
            }
            else if (typeof node === 'string') {
                return new Str_1.Str(node);
            }
            return node;
        }
        return visit(data);
    }
    YAML.fromYaml = fromYaml;
    function toYaml(chain, data) {
        return js_yaml_1.safeDump(data, { schema: createSchema(chain) });
    }
    YAML.toYaml = toYaml;
})(YAML = exports.YAML || (exports.YAML = {}));
exports.fromYaml = YAML.fromYaml;
exports.toYaml = YAML.toYaml;
exports.default = YAML;
//# sourceMappingURL=YAML.js.map